export enum NutritionLabelCountry {
  Canada = 0,
  US = 1,
  UK = 2
}
